import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CompetitorVehicleService {
  constructor(private readonly http: HttpClient) {}

  public getCompetitorVehicleReportMenuOptions(): Observable<any> {
    const url = `${environment.serviceURL}/competitorVehicleReportMenuItems`;
    return this.http.get<any>(url);
  }

  public getCompetitorVehicleReportData(
    year: string | any[],
    segments: string | any[],
    regions: string | any[]
  ): Observable<any> {
    const url = `${environment.serviceURL}/competitorVehicleReportData`;
    return this.http.post<any>(url, { year, segments, regions });
  }

  public exportToExcel(
    year: string | any[],
    segments: string | any[],
    regions: string | any[]
  ): Observable<any> {
    const url = `${environment.serviceURL}/competitorVehicleReportExportToExcel`;
    const headers = new HttpHeaders();
    headers["Content-Disposition"] = "attachment; filename=filename.pdf";

    return this.http.post(
      url,
      { year, segments, regions },
      { headers, responseType: "blob" }
    );
  }
}
